import { useNavigate } from "react-router-dom";
import { Button } from "react-scroll";
import { CalendarSvg, PremiumServiceSvg } from "../../components/Assets";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import TopPageBack from "../../components/TopPageBack";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import { useState, useEffect } from 'react';
import CeoApi from "../../apis/ceo.api";
import Spinner from "../../components/spinner/Spinner";
import { store } from "../../store";
import UserApi from "../../apis/user.api";
import Str2DateWithDot from "../../utils/Str2DateWithDot";


const CancelDeleteAccount = function () {
  const navigate = useNavigate();
  const { ceoInfo } = useAuth();
  const [loading, setLoading] = useState(false);
  const [isAccountDeleted, setIsAccountDeleted] = useState(true);
  const [requestDeleteDttm, setRequestDeleteDttm] = useState('');
  const [estimatedDeletionDttm, setEstimatedDeletionDttm] = useState('');

  useEffect(() => {
    console.log(store.getState())
    setIsAccountDeleted(store.getState().CeoStatus['isDeleted']);
    setRequestDeleteDttm(store.getState().Ceo['requestDeleteDttm']);
    setEstimatedDeletionDttm(store.getState().Ceo['estimatedDeletionDttm']);
  }, []);
  const onSubmit = async () => {
    setLoading(true);
    try {
      const res = await UserApi.cancelDeleteAccount();
      if (res.data.data) {
        navigate(ROUTE_PATHS.Home);
      }
    } catch (error) {

    } finally {
      setLoading(false);
    }
  }
  return (
    <div>
      <TopPageBack>
        <b>탈퇴하기</b>
      </TopPageBack>
      {isAccountDeleted ? (
        <div className="mt-4 mx-5 pb-16">
          <div className="text-lg font-bold mb-1">이미 접수된 서비스 탈퇴 </div>
          <div className="text-lg font-bold mb-1">신청서가 있어요.</div>

          <div className="review-card2 py-4 mt-6 flex flex-col">
            <div className="flex flex-col gap-2">
              <div className="text-lg font-bold mb-1">신청 정보</div>
              <div className="bg-light-aqua2 p-4 rounded-lg ">
                <div className="mb-8">
                  <div className="text-15 text-darkblue">탈퇴 신청일</div>
                  <div className="text-base font-bold text-darkblue">
                  { Str2DateWithDot(requestDeleteDttm)}
                  </div>
                </div>
                <div>
                  <div className="text-base text-darkblue">탈퇴 예정일</div>
                  <div className="text-base font-bold text-darkblue">
                  {estimatedDeletionDttm?.replaceAll('/','.')}<span className="font-normal">(00시)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="pt-3 mx-5">
            <ul>
              <li style={{ listStyleType: "initial" }} className=" mb-5  text-base  text-darkblue">
                탈퇴 예정일까지는 모든 서비스를 정상적으로 이용하실 수 있어요.
              </li>
            </ul>
          </div>
          <div className="px-5 absolute w-full bottom-2 left-0">
            <SolidBlueBtn
              disabled={loading}
              className="w-full flex items-center justify-center"
              onClick={onSubmit}
            >
              <Spinner isLoading={loading} />
              탈퇴 취소
            </SolidBlueBtn>
          </div>
        </div>
      ) : <div></div>}
    </div>
  );
};
export default CancelDeleteAccount;
